import { Button, HStack, useDisclosure } from '@chakra-ui/react';
import { t } from 'i18next';
import { useEffect, useState, type FC } from 'react';

import { MobileDrawer } from '$/components/common/Drawer/MobileDrawer';
import { Icon } from '$/components/common/Icon';
import { MobileFilter } from '$/components/core/Collection/CollectionFilter/components/MobileFilter/MobileFilter';
import { MobileFilterDrawerContent } from '$/components/core/Collection/CollectionFilter/components/MobileFilter/MobileFilterDrawerContent';
import { useFilterOptions } from '$/hooks/data/useFilterOptions';
import { useIsMobile } from '$/hooks/useIsMobile';

interface Props {
  amount?: number;
}

export const MobileFilterDrawer: FC<Props> = ({ amount }) => {
  const isMobile = useIsMobile();

  const { data: filter } = useFilterOptions();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [subFilter, setSubFilter] = useState<string | null>(null);

  useEffect(() => {
    if (!isOpen && subFilter) setSubFilter(null);
  }, [isOpen, subFilter]);

  useEffect(() => {
    if (!isMobile && isOpen) onClose();
  }, [isMobile, isOpen, onClose]);

  return (
    <>
      <HStack>
        {filter && (
          <MobileFilter
            width='auto'
            flexGrow='5'
            filterGroup={
              filter.general.find((f) => f.searchField === 'collection')!
            }
            filterIcon='chevron_down'
            onSingleFilterSelected={(subFilter) => {
              setSubFilter(subFilter);
              onOpen();
            }}
          />
        )}

        <Button
          px='4'
          py='2'
          color='textButton.color'
          fontSize='sm'
          bg='background'
          borderWidth='1px'
          borderColor='border'
          borderRadius='8px'
          _hover={{ bg: 'background' }}
          _active={{ bg: 'background' }}
          onClick={onOpen}
          rightIcon={<Icon icon='filter_alt' boxSize='14px' />}
        >
          {t('dashboard.collection.filter.mobile.filterButton')}
        </Button>
      </HStack>

      <MobileDrawer isOpen={isOpen} onClose={onClose}>
        <MobileFilterDrawerContent
          amount={amount}
          onClose={onClose}
          setSubFilter={setSubFilter}
          subFilter={subFilter}
        />
      </MobileDrawer>
    </>
  );
};
